var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrivacyPolice(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3690",
    d: "M0-682.665H21v21H0Z",
    transform: "translate(0 682.665)",
    fill: "#bcbcbc"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "privacy_police",
    transform: "translate(0 682.665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3686",
    transform: "translate(0 -682.665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3688",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3694",
    transform: "translate(13.941 14.594)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3696",
    d: "M-79.156,0l-2.512.711V2.685a3.182,3.182,0,0,0,1.542,2.727l.97.583.97-.583a3.182,3.182,0,0,0,1.542-2.727V.711Z",
    transform: "translate(81.668)",
    fill: "none",
    stroke: "#bcbcbc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3698",
    transform: "translate(2.034 0.41)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3700",
    d: "M0-343.447v7.5H12.3a3.18,3.18,0,0,1-.395-1.535v-1.973l2.512-.711v-14.184H0v7.3",
    transform: "translate(0 354.347)",
    fill: "none",
    stroke: "#bcbcbc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3702",
    transform: "translate(15.718 16.723)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3704",
    d: "M0-19.069l.567.567L1.74-19.675",
    transform: "translate(0 19.675)",
    fill: "none",
    stroke: "#bcbcbc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3706",
    transform: "translate(4.764 3.167)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3708",
    d: "M-85.48-42.739a1.356,1.356,0,0,1-1.356,1.356,1.356,1.356,0,0,1-1.357-1.356A1.357,1.357,0,0,1-86.837-44.1,1.356,1.356,0,0,1-85.48-42.739Z",
    transform: "translate(88.193 44.096)",
    fill: "none",
    stroke: "#bcbcbc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3710",
    transform: "translate(4.764 8.163)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3712",
    d: "M-85.48-42.739a1.356,1.356,0,0,1-1.356,1.356,1.356,1.356,0,0,1-1.357-1.356A1.357,1.357,0,0,1-86.837-44.1,1.356,1.356,0,0,1-85.48-42.739Z",
    transform: "translate(88.193 44.096)",
    fill: "none",
    stroke: "#bcbcbc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3714",
    transform: "translate(4.764 13.158)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3716",
    d: "M-85.48-42.738a1.356,1.356,0,0,1-1.356,1.356,1.356,1.356,0,0,1-1.357-1.356,1.356,1.356,0,0,1,1.357-1.356A1.356,1.356,0,0,1-85.48-42.738Z",
    transform: "translate(88.193 44.095)",
    fill: "none",
    stroke: "#bcbcbc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3718",
    transform: "translate(9.788 3.736)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3720",
    d: "M0,0H3.976",
    fill: "none",
    stroke: "#bcbcbc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3722",
    transform: "translate(9.788 5.545)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3724",
    d: "M0,0H2.169",
    fill: "none",
    stroke: "#bcbcbc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3726",
    transform: "translate(9.788 8.615)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3728",
    d: "M0,0H3.976",
    fill: "none",
    stroke: "#bcbcbc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3730",
    transform: "translate(9.788 10.423)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3732",
    d: "M0,0H2.169",
    fill: "none",
    stroke: "#bcbcbc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3734",
    transform: "translate(9.788 13.494)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3736",
    d: "M0,0H3.976",
    fill: "none",
    stroke: "#bcbcbc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3738",
    transform: "translate(9.788 15.302)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3740",
    d: "M0,0H2.169",
    fill: "none",
    stroke: "#bcbcbc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3742",
    transform: "translate(2.034 9.519)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3744",
    d: "M0,0H0",
    fill: "none",
    stroke: "#bcbcbc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacyPolice);
export default __webpack_public_path__ + "static/media/privacy_police.6d2e6884ff64b62c403932e25de90348.svg";
export { ForwardRef as ReactComponent };